import { render, staticRenderFns } from "./AssemblySheetPricingFragment.vue?vue&type=template&id=2c3c47d4"
import script from "./AssemblySheetPricingFragment.vue?vue&type=script&lang=js"
export * from "./AssemblySheetPricingFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports